import { render, staticRenderFns } from "./NewEntityModal.vue?vue&type=template&id=3ba6c874&scoped=true&"
import script from "./NewEntityModal.vue?vue&type=script&lang=js&"
export * from "./NewEntityModal.vue?vue&type=script&lang=js&"
import style0 from "./NewEntityModal.vue?vue&type=style&index=0&id=3ba6c874&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba6c874",
  null
  
)

export default component.exports